export const Config = {
  languages: {
    en: 'English',
    // fr: 'Français',
    it: 'Italiano',
  },
  
  pages: {
    logged_user_home: 'dashboard'
  },

  /**
   * Le rotte qui definite richiedono l'autenticazione dell'utente.
   * Se c'è anche la proprietà "permissions" controlla anche i permessi.
   */
  // protectedPages: {
  //   admin: { permissions: ['view-backend'] },
  //   settings: {},
  //   tournaments: {},
  // },

  path: {
  },
  
  server: {
    routes: {
      api: {
        // Auth and permissions
        forgot_password: 'forgot-password',
        login: 'login',
        logout: 'logout',
        register: 'register',
        reset_password: 'reset-password',
        permissions: 'permissions',

        // Tournaments
        add_entry: 'tournaments/{tournament}/add-entry',
        add_team: 'tournaments/{tournament}/add-team',
        add_game_entry: 'games/{game}/add-entry',
        remove_game_entry: 'games/{game}/remove-entry',
        add_group_entry: 'groups/{group}/add-entry',
        delete_entry: 'tournaments/{tournament}/delete-entry',
        delete_round: 'rounds/{round}',
        delete_team: 'tournaments/{tournament}/delete-team',
        recalculate_standings: 'groups/{group}/recalculate-standings',
        remove_group_entry: 'groups/{group}/remove-entry',
        round: 'rounds/{round}',
        rounds_add_many: 'rounds/add-many',
        tournament_close_season: 'tournaments/{tournament}/close-season',
        tournament_hof: 'tournaments/{tournament}/hof',
        tournament_new_season: 'tournaments/{tournament}/new-season',
        tournament_seasons: 'tournaments/{tournament}/seasons',
        tournaments: 'tournaments',
        update_entry: 'tournaments/{tournament}/update-entry',
        update_team: 'tournaments/{tournament}/update-team',
        update_round: 'rounds/{round}',
        update_settings: 'tournaments/{tournament}/update-settings',
        update_group_entries: 'groups/{group}/update-entries',
        update_game_entries: 'games/{game}/update-entries',

        // User related
        dashboard: 'dashboard',
      }
    }
  },


  tournament: {
    /**
     * These configurations must be the same as the server ones
     * @see ../../server/config/tournament.php
     */
    states: [
      'draft',
      'running',
      'archived',
      'cancelled',
    ],

    season_states: [
      'running',
      'completed',
      'cancelled',
    ],

    round_states: [
      'scheduled',
      'running',
      'completed',
      'cancelled',
    ],

    award_types: {
      winner: {},
      runner_up: {},
      third_place: {},
    },

    standingsColumns: [
      { key: 'points', type: 'integer', enabled: true, sortingType: 'desc' },
      { key: 'played', type: 'integer', enabled: false, sortingType: 'asc' },
      { key: 'wins', type: 'integer', enabled: true, sortingType: 'desc' },
      { key: 'podiums', type: 'integer', enabled: false, sortingType: 'desc' },
      { key: 'draws', type: 'integer', enabled: false, sortingType: 'asc' },
      { key: 'losses', type: 'integer', enabled: false, sortingType: 'asc' },
      { key: 'score_for', type: 'integer', enabled: false, sortingType: 'desc' },
      { key: 'score_against', type: 'integer', enabled: false, sortingType: 'asc' },      
      { key: 'score_difference', type: 'integer', enabled: false, sortingType: 'desc' },
      { key: 'dnf', type: 'integer', enabled: false, sortingType: 'asc' },
    ],

  },

  entryFlags: {
    dnf: { icon: 'mdi-ghost-off-outline', color: 'amber' },
    // pole: { icon: 'mdi-flag-checkered' },
  }
}